import { render, staticRenderFns } from "./BrandLogoTextboxAdulte.vue?vue&type=template&id=957ba88a&"
import script from "./BrandLogoTextboxAdulte.vue?vue&type=script&lang=js&"
export * from "./BrandLogoTextboxAdulte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports